import Cookie from 'js-cookie';
import type { SessionData } from '../utils';

import { isValidSessionData } from '../utils';
// Deep import to bypass the @farmersdog/utils barrel — the barrel re-exports
// React hooks and other heavy modules that would otherwise be pulled into any
// bundle that imports from sessions. Keep this path stable when moving files
// in @farmersdog/utils/src.
import { getCookieDomain } from '@farmersdog/utils/src/getCookieDomain';

export const STORAGE_KEY = 'tfd-segment-session-data';

export type CookieStorageSessionDataReturn = SessionData | null;

/**
 * Retrieve the session id from local storage
 */
function get(): CookieStorageSessionDataReturn {
  const sessionDataString = Cookie.get(STORAGE_KEY);
  try {
    if (!sessionDataString) {
      return null;
    }

    const parsedSessionData = JSON.parse(sessionDataString) as unknown;
    return isValidSessionData(parsedSessionData) ? parsedSessionData : null;
  } catch {
    return null;
  }
}

/**
 * Write the session id to local storage
 */
function set(sessionData: SessionData) {
  const sessionDataString = JSON.stringify(sessionData);
  Cookie.set(STORAGE_KEY, sessionDataString, {
    path: '/',
    expires: new Date(sessionData.expiration),
    domain: getCookieDomain(),
  });
}

export const cookieStorageSessionData = {
  get,
  set,
};
